<div class="books-modal-wrapper">

    <div class="row">
        <div class="col-md-12">
            <div class="header-modal mb-3">
                <h2>Star Mentors</h2>
                <button (click)="close()" data-modal-element-close-button="" class="modal-close-button" data-modal-close="" aria-label="Close Getting started section">
                    <span data-modal-element-close-icon="" class="modal-close-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"></path></svg></span>
                </button>
            </div>
        </div>
    </div>
    

    <div class="row">
        <p>Know about the top CAT mentors at iQuanta CAT coaching. We have the best mentors at iQuanta to help the students with the CAT preparation such as </p>
        <ul>
            <li>Indrajeet Singh (Founder & CEO)</li>
            <li>Raj Kumar Jha (6 times CAT QA 100%iler and 2 times XAT 99.99%iler)</li>
            <li>Vikrant Kathuria (VARC Master, VARC 100%iler & 100% scorer)</li>
            <li>Abhishek Leela Pandey (CAT 99.93%iler)</li>
            <li>Kamal Lohia (CAT 99.99%iler)</li>
            <li>Prashant Chadha (8 times CAT VARC 99%iler)</li>
        </ul>
    </div>
    <div class="row">
        
        <div class="col-md-4">
            <div class="img mb-md-0 mb-4">
                <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/star-mentors-09-66e816f8e62dd.webp" alt="iQuanta Mentors">
            </div>
        </div>

        <div class="col-md-4">
            <div class="img mb-4">
                <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/star-mentors-02-66e816f86495c.webp" alt="iQuanta Mentors">
            </div>
        </div>

        <div class="col-md-4">
            <div class="img mb-md-0 mb-4">
                <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/star-mentors-07-66e816f59c53e.webp" alt="iQuanta Mentors">
            </div>
        </div>

        <div class="col-md-4">
            <div class="img mb-4">
                <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/star-mentors-04-66e816f59655f.webp" alt="iQuanta Mentors">
            </div>
        </div>
        
        <div class="col-md-4">
            <div class="img mb-md-0 mb-4">
                <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/star-mentors-06-66e816f263864.webp" alt="iQuanta Mentors">
            </div>
        </div>

        
        <div class="col-md-4">
            <div class="img mb-4">
                <img src="https://media.iquanta.in/ui_images/star-mentors-03.jpeg" alt="iQuanta Mentors">
            </div>
        </div>


        <!-- <div class="col-md-4">
            <div class="img mb-md-0 mb-4">
                <img src="https://media.iquanta.in/ui_images/star-mentors-05.jpeg" alt="iQuanta Mentors">
            </div>
        </div> -->

      
       

        <div class="col-md-4">
            <div class="img mb-md-0 mb-4">
                <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/star-mentors-08-66e816f243f5a.webp" alt="iQuanta Mentors">
            </div>
        </div>
        
    </div>
</div>